<template>
  <div class="fbt">
    <div v-if="hasOriginals" class="fbt__toggle-row">
      <button
        type="button"
        class="fbt__toggle"
        :class="{ 'fbt__toggle--active': showOriginal }"
        @click.stop="showOriginal = !showOriginal"
      >
        <v-icon x-small class="mr-1">mdi-translate</v-icon>
        {{ showOriginal ? "Übersetzung" : "Original" }}
      </button>
    </div>
    <div v-for="(entry, index) in entries" :key="index" class="fbt__entry">
      <div class="fbt__text">
        {{ showOriginal ? (entry.original || entry.translated) : (entry.translated || entry.original) }}
      </div>
      <div v-if="entry.timestamp || entry.locale" class="fbt__meta">
        <span v-if="entry.timestamp">{{ timeAgo(entry.timestamp) }}</span>
        <span v-if="entry.locale"> · {{ entry.locale }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateFromNow } from "@/utils";

/**
 * Kunden-Feedback als sauberer Thread (neueste zuerst) auf Basis des
 * strukturierten feedback.comments-Arrays. Default: Übersetzung;
 * Umschalter zeigt den Original-Kundentext. Alt-Tasks ohne Array fallen
 * auf den zusammengesetzten Legacy-String zurück.
 */
export default {
  name: "FeedbackThread",
  props: {
    feedback: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showOriginal: false,
    };
  },
  computed: {
    entries() {
      const fb = this.feedback || {};
      if (Array.isArray(fb.comments) && fb.comments.length) {
        return [...fb.comments].reverse(); // neueste zuerst
      }
      if (fb.comment) {
        return [{ original: fb.commentOriginal || "", translated: fb.comment }];
      }
      return [];
    },
    hasOriginals() {
      return this.entries.some(
        e => e.original && e.translated && e.original !== e.translated
      );
    },
  },
  methods: {
    timeAgo(timestamp) {
      return getDateFromNow(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.fbt {
  &__toggle-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 6px;
  }

  &__toggle {
    display: inline-flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 10px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.55);

    .v-icon {
      color: inherit !important;
    }

    &--active {
      background: #eef0f3;
      color: rgba(0, 0, 0, 0.8);
    }
  }

  &__entry {
    background: #f6f8fa;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 8px 12px;
    margin-bottom: 6px;

    /* Ältere Kommentare gedimmt — der neueste steht oben im Fokus */
    &:not(:first-child) {
      opacity: 0.65;
    }
  }

  &__text {
    font-size: 14px;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
  }

  &__meta {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.4);
    margin-top: 3px;
  }
}
</style>
